import React, { Component } from 'react';
class Footer extends Component {

    render() {
        const settings = this.props.app.settings.address;
        return <footer className="footer">
            <div className="container">
                <div className="columns">
                    <div className="column">
                        <div className="ftr first-line">&copy; {settings.bizname} 2023  </div>
                        <div className="ftr">{settings.address} | {settings.phone} </div>
                        <div className="ftr"><a href="https://garciatech.com">Garciatech.com</a>  V101223</div>
                    </div>
                </div>
            </div>
        </footer>
    }
}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js